import { Box } from '@mui/material';

export interface MenuInterface{
  icon: React.ReactNode;
  text: string;
  method?: ()=> void;
}
interface MenuItemTypes {
  listMenuInterface: MenuInterface[];
}

const MenuItem = (props: MenuItemTypes) => {

  return (
    <>
      {props.listMenuInterface.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: index == 0 ? "0px" : "5px",
            paddingBottom: props.listMenuInterface.length - 1 == index ? "0px" : "5px",
            paddingRight:"10px",
            borderTop: index != 0 ? "0.1px solid #00000014" : "none"
          }}
          onClick={item.method}
        >
          { item.icon }
          <Box
            sx={{
              ml: "5px"
            }}
          >
            {item.text}
          </Box>
        </Box>
      ))}
    </>
  );
}

export default MenuItem;